import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = () => {
  const location = useLocation();
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    setIsAnimating(true);
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 600);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!isAnimating) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0, 0, 0, 0.25)',
        zIndex: 9999,
        pointerEvents: 'none',
        animation: 'pageTransitionClose 0.6s ease-in-out forwards',
      }}
    />
  );
};

export default PageTransition;
